import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { of } from 'rxjs'
import { EnvironmentService } from './environment.service'
import { RedirectService } from './redirect.service'
import { UsersApiService } from './users-api.service'
import { map, catchError } from 'rxjs/operators'
import { Params } from '@angular/router'

@Injectable({
  providedIn: 'root'
})
export class LoggedInService {
  constructor(
    private _environmentService: EnvironmentService,
    private _redirectService: RedirectService,
    private _userApiService: UsersApiService
  ) {
  }

  public isLoggedIn(): Observable<boolean> {
    return this._userApiService.loginWithAuthToken().pipe(
      map((user) => this.redirectIfUser(user)),
      catchError((_err) => of(true))
    )
  }

  public redirectIfUser(user) {
    if (user) {
      this._redirectService.redirectTo(this._redirectUrlFromParams(this._getParams()))
      return false
    }
    return true
  }

  private _getParams(): Params {
    // Angular cannot determine the query params on load through the Router
    // see: https://github.com/angular/angular/issues/12157
    return window.location.search.length === 0 ? {} :
      window.location.search.substr(1)
        .split('&').map((pairString) => pairString.split('='))
        .reduce((out, pair) => {
          out[pair[0]] = decodeURIComponent(pair[1])
          return out
        }, {})
  }

  private _redirectUrlFromParams(params: Params) {
    return params['redirectUrl'] || this._environmentService.get('ATLAS_URL')
  }
}
